import React, { useState } from 'react';
import { AxiosError } from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { SelectAnotherProvider } from '@app/components';
import { parseString } from '@app/helpers';
import { SetLoginForm } from '@app/models';
import { TwoFactorOtp } from '@app/modules/mfaToken/components';
import { onSubmitOtp } from '../helpers';

interface IProps {
    setLoginForm: SetLoginForm;
    rememberMe: boolean;
}

export const SignInTwoFactorOtp: React.SFC<IProps> = ({ setLoginForm, rememberMe }) => {
    const error: AxiosError<any> = useSelector((state: any) => state.signIn.error);
    const errorUri = error?.response?.data?.error_uri ?? '';
    const { context: contextToken, providers } = parseString(window.atob(errorUri));
    const dispatch = useDispatch();
    const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);

    return (
        <>
            <TwoFactorOtp
                setLoginForm={setLoginForm}
                isLoggingIn={isLoggingIn}
                onSubmit={onSubmitOtp(dispatch, contextToken, setIsLoggingIn, rememberMe)}
                isMultipleProviders={providers.length > 1}
            />
            <SelectAnotherProvider setLoginForm={setLoginForm} />
        </>
    );
};
